<hr id="divider" />

<style>
  #divider {
    width: 90vw;
    border-top: 2px solid #bbb;
    border-radius: 0.5px;
  }
</style>
